module.exports = __webpack_public_path__ + "assets/4.82a46875.png";